import { z } from 'zod'

import { REQUIRED_FIELD_MESSAGE } from '@/constants'
import { articleSchema, barcodeSchema, supplierArticlesSchema } from '@/schemas'

export const nomenclatureCreationSchema = z.object({
  article: articleSchema.min(1, REQUIRED_FIELD_MESSAGE),
  supplierArticles: supplierArticlesSchema.optional(),
  supplierArticleDraft: z.string().optional(),
  description: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE),
  brand: z.object(
    {
      value: z.string().trim(),
      label: z.string().trim(),
    },
    { required_error: REQUIRED_FIELD_MESSAGE }
  ),
  category: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE),
  nomenclatureGroup: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE),
  barcode: barcodeSchema.optional(),
  countryOfOrigin: z
    .object({
      value: z.string().trim(),
      label: z.string().trim(),
    })
    .optional(),
  warranty: z.string().trim().optional(),
  itemWeight: z.string().trim().optional(),
  itemLength: z.string().trim().optional(),
  itemWidth: z.string().trim().optional(),
  itemHeight: z.string().trim().optional(),
  unitOfMeasurement: z
    .object({
      value: z.string().trim(),
      label: z.string().trim(),
    })
    .optional(),
  details: z.string().trim().optional(),
  comment: z.string().trim().optional(),
})

export type NomenclatureCreationType = z.infer<
  typeof nomenclatureCreationSchema
>
